import { FilterHandler } from './FilterHandler'

class RangeFilterHandler extends FilterHandler {
  shouldSetParam = (value, urlSearchParams) => {
    const otherParam = urlSearchParams.get(this.filter.id)
    const isOtherMinOrMax =
      this.filter.minAllowedValue == otherParam ||
      this.filter.maxAllowedValue == otherParam
    const isMinOrMax =
      this.filter.minAllowedValue == value || this.filter.maxAllowedValue == value

    console.log(
      `Comparing range for: this (${value}): ${isMinOrMax}, other (${otherParam}): ${isOtherMinOrMax}`,
      this.filter
    )

    const shouldSet = !isOtherMinOrMax || !isMinOrMax

    console.log(`Range found with ${value} -- should set -- ${shouldSet}`, this.filter)

    if (!shouldSet) {
      //remove the bottom of range item if we don't want to set it
      urlSearchParams.delete(this.filter.id)
    }

    return shouldSet
  }
}

export { RangeFilterHandler }
